<template>
  <div>
    <CRow>
      <CCol xs="12" sm="12" md="12" lg="12" xl="12">
        <CCard>
          <CCardHeader>
            <div class="form-group">
              <label>Thông tin nhập/xuất</label>
              <CButton v-if="!isDone" style="float: right;margin-left: 5px;margin-top: 2px; min-width:40px" color="primary" class="btn-action-primary" @click="addLine()"> 
                <i class="fa fa-plus"></i>Tạo dòng mới </CButton>
            </div>

          </CCardHeader>
          <CCardBody>
            <CDataTable :items="products" :fields="productFields" :sorterValue="{ column: null, asc: 'true' }"
              ref="productTables" hover>
              <template #stt="{ index }">
                <td>{{ index + 1 }}</td>
              </template>
              <template #productId="{ item }">
                <td class="form-group">
                  <input type="text" :placeholder="item.productName"
                      class="form-control" readonly v-model="item.productName" :disabled="isDone"
                      @click="chooseProduct(item)"/>
                </td>
              </template>
              <template #unitPrice="{ item }">
                <td>
                  <currency-input class="form-control" v-model="item.unitPrice" @change="sumTotal(item)" currency="VND" locale="vi" :disabled="isDone" />
                </td>
              </template>
              <template #quantity="{ item }">
                <td>
                  <input class="form-control" type="number" @change="changeQuantity(item)" v-model="item.quantity" :disabled="item.isByLotSerial || isDone"/>
                </td>
              </template>
              <template #warranty="{ item }">
                <td>
                  <input class="form-control" type="number" min="0" v-model="item.warranty" :disabled="isDone"/>
                </td>
              </template>
              <template #dateWarranty="{ item }">
                <td>
                  <input class="form-control" type="text" :value="item.dateWarranty ? $helper.formatDateDDMMYYYY(item.dateWarranty) : ''" disabled="true"/>
                </td>
              </template>
              <template #totalPrice="{ item }">
                <td>
                  <currency-input :disabled="true" class="form-control" :value="item.unitPrice * item.quantity" currency="VND"
                    locale="vi" />
                </td>
              </template>
              <template slot="no-items-view">
                <span style="color:#969696;">Danh sách trống!</span>
              </template>
              <template #action="{ item }">
                <td class="action-btn-group">
                  <div class="action-btn-wrapper">
                    <CButton color="success" variant="outline" class="ml-1" square size="sm" v-c-tooltip.hover="'Thêm Lot/Serial'" v-if="item.isByLotSerial"
                      @click="addLotSerial(item)">
                      <CIcon name="cil-spreadsheet" />
                    </CButton>
                    <CButton v-if="!isDone" color="danger" variant="outline" class="ml-1" square size="sm" v-c-tooltip.hover="'Xóa'"
                      @click="setupSelectOneAction('delete_one', item)">
                      <CIcon name="cil-trash" />
                    </CButton>
                  </div>
                </td>
              </template>
            </CDataTable>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>

    <BaseChooseProduct v-if="isShowChooseProduct" @item:selected="chooseProductSelected($event)"
      @close-modal="closeModelProduct($event)"></BaseChooseProduct>

    <BaseStockProductLotScan v-if="isShowScanProductLot" :isDone="isDone" :itemAddSerial="itemAddSerial" @item:selected="scanProductLotSelected($event)"
      @sum-total = "sumTotal()"
      @close-modal="closeModelScanProductLot($event)">
    </BaseStockProductLotScan>

    <BaseFormLoading :value="loading.value"></BaseFormLoading>

    <ModalConfirm2 :actionTypeMapping="actionData.actionTypeMapping" ref="actionModal"></ModalConfirm2>
  </div>
</template>
  
<script>
import BaseTable from "../base/BaseDataTable";
import ModalConfirm from "../base/BaseModalConfirm";
import BaseInput from "../base/BaseInput";
import BaseSwitch from "@/views/base/BaseSwitch";
import BaseSelect from "@/views/base/BaseSelect2";
import BaseFormLoading from "@/views/base/BaseFormLoading";
import BaseChooseProduct from "@/views/base/BaseChooseProduct";
import BaseStockProductLotScan from "@/views/base/BaseStockProductLotScan";
import ModalConfirm2 from '@/views/base/BaseModalConfirm2.vue';

export default {
  name: "StockInventoryLines",
  components: {
    BaseSwitch,
    BaseTable,
    ModalConfirm,
    BaseInput,
    BaseSelect,
    BaseFormLoading,
    BaseChooseProduct,
    BaseStockProductLotScan,
    ModalConfirm2
  },
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success"
    },
    showErrorMsg: {
      type: "error",
      title: "Error"
    },
    showWarningMsg: {
      type: "warn",
      title: "warn"
    }
  },
  props: ["products", "removeListLine", "isDone"],
  data() {
    let that = this;

    let actionTypeMapping = new Map();
  
    actionTypeMapping.set("delete_one", {
        titlePopup: function () {
            return that.$helper.setupTitleAction(
                "xóa bản ghi",
                that.actionData.model.itemSelected.productName
            );
        },
        submitAction: function () {
            that.removeLine(that.actionData.model.itemSelected);
        },
    });

    return {
      loading: { value: false },
      isShowChooseProduct: false,
      isShowScanProductLot: false,
      itemChooseProduct: {},
      itemAddSerial: {},
      isDoneDetail: this.isDone,
      actionData: {
        actionTypeMapping: actionTypeMapping,
        model: {
            itemSelected: '',
        }
      },
      productFields: [
          {key: 'stt', label: 'STT', _style:'width: 5%;'},
          {key: 'productId', label: 'Sản phẩm', _style:'width: 20%;'},
          {key: 'warranty', label: 'Bảo hành (tháng)', _style:'width: 5%;'},
          {key: 'dateWarranty', label: 'Ngày hết bảo hành', _style:'width: 5%;'},
          {key: 'unitPrice', label: 'Đơn giá', _style:'width: 10%;'},
          {key: 'quantity', label: 'Số lượng', _style:'width: 10%;'},
          {key: 'totalPrice', label: 'Thành tiền', _style:'width: 10%;'},
          {key: 'action', label: 'Thao tác', _style:'width: 10%;'},
      ],
    };
  },
  methods: {
    chooseProduct(item) {
      this.itemChooseProduct = item;
      this.isShowChooseProduct = true;
    },
    chooseProductSelected(event) {
      this.itemChooseProduct.productId = event.id;
      this.itemChooseProduct.productName = event.name;
      this.itemChooseProduct.isByLotSerial = event.isByLotSerial;
      this.isShowChooseProduct = false;
    },
    closeModelProduct() {
      this.isShowChooseProduct = false
    },
    addLotSerial(item) {
      this.itemAddSerial = item;
      this.isShowScanProductLot = true;
    },
    scanProductLotSelected() {
      this.isShowScanProductLot = false
    },
    closeModelScanProductLot() {
      this.isShowScanProductLot = false
    },
    generateUniqueId() {
      let existingIds = this.products.map(item => item.id)
      let newId;
      do {
          // Tạo ID mới, ví dụ: một chuỗi ngẫu nhiên có chiều dài 6
          newId = 'NEW' + Math.random().toString(36).substring(2, 8);
      } while (existingIds.includes(newId)); // Kiểm tra xem ID đã tồn tại chưa

      return newId;
    },
    addLine() {
      this.products.push(
        {
          id: this.generateUniqueId(),
          productId: 0,
          unitPrice: 0,
          quantity: 0,
          totalPrice: 0,
          warranty: 0,
          isByLotSerial: false,
          stockProductLotSerials: [],
          isUpdateLot: true,
          lstIdRemoveStockPrdLot: []
        }
      )
    },
    removeLine(item) {
      let that = this;
      const indexToRemove = that.products.findIndex(i => i.id === item.id);
      that.products.splice(indexToRemove, 1);
      if(!item.id.toString().includes('NEW')) {
          // if(!that.removeListLine) {
          //   that.removeListLine = [];
          // }
          that.removeListLine.push(item.id);
      }
      that.sumTotal();
    },
    sumTotal(item) {
      // let totalQuantity = 0;
      // let totalPrice = 0;
      // for (let i = 0; i < this.products.length; i++) {
      //   totalQuantity += this.products[i].quantity;
      //   totalPrice += (this.products[i].unitPrice * this.products[i].quantity);
      // }
      // this.$emit("sum-total", totalQuantity, totalPrice);
      // if(item.quantity < 0) {
      //   item.quantity = 0;
      // }
      this.$emit("sum-total");
    },
    changeQuantity(item) {
      if(item.quantity < 0) {
        item.quantity = 0;
      }
      this.sumTotal();
    },
    
    setupSelectOneAction: function (actionTypeKey, item) {
      let actionData = this.actionData.model;
      actionData.itemSelected = item || null;
      this.$refs.actionModal.setCurrAction(actionTypeKey);
    },
  },
  created: function () {
  },
  mounted() {
    // this.addLine()
  },
  watch: {
  },
  computed: {
  }
};
</script>
  